import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    marginTop : {
      marginTop: "30px"
    }
}));


const TalentIdentity = (props) => {
    const classes = useStyles();
    return (
        <>  
        <Grid container direction="column" alignItems="center">
            <Grid item xs={12} className={classes.marginTop}>
            <img
            src={props.user && props.user.picture}
            alt="avatar"
            style={{ width: "80px", borderRadius: 400 / 2 }}
            />
            </Grid>
        <Grid item xs={12} className={classes.marginTop}>
            <h3 style={{ color: "white", fontFamily: "Nunito" }}>
            {props.user && props.user.name}
            </h3>
            </Grid>
        </Grid>
        <br/>
        </>
    );
}
 
export default TalentIdentity;